export function safeParseFloat(value: string): number | null {
  const parsed = parseFloat(value);
  if (Number.isNaN(parsed) || parsed.toString() !== normalizeFloatInput(value)) {
    return null;
  }
  return parsed;
}

export function safeParseInt(value: string): number | null {
  const parsed = parseFloat(value);
  if (Number.isNaN(parsed) || parsed.toString() !== value) {
    return null;
  }
  if (!Number.isInteger(parsed)) {
    return null;
  }
  return parsed;
}

function normalizeFloatInput(value: string): string {
  if (value.startsWith(".")) {
    return `0${value}`;
  }

  if (value.startsWith("-.")) {
    return value.replace("-.", "-0.");
  }

  if (value.endsWith(".")) {
    return value.slice(0, -1);
  }

  return value;
}
